<div class="space-y-2">
  <div
    #mapContainer
    class="location-map"
    role="region"
    aria-label="Selector de ubicación geográfica"
    [attr.aria-disabled]="disabled"
  ></div>

  <p class="text-sm text-gray-500 dark:text-gray-400">
    @if (disabled) {
      Ubicación registrada. Habilite la edición para modificarla.
    } @else {
      Haga clic sobre el mapa o arrastre el marcador para completar las coordenadas.
    }
  </p>
</div>
